@if (params.value === 1) {
<span>{{'FIELD' | translate}}</span>
} @if (params.value === 2) {
<span>{{'CAMPAIGN' | translate}}</span>
}
